import axios from "axios";
import React, { createContext, useContext, useState, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { GlobalContext } from "./GlobalContext";

const UserContext = createContext(null);

// Custom hook for using the context
export const useGlobal = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useGlobal must be used within a UserProvider");
  }
  return context;
};

export const UserProvider = ({ children }) => {
  const [userData, setUserData] = React.useState({});
  const { hitAxios } = React.useContext(GlobalContext);
  const [addon, setAddon] = React.useState([]);

  async function updateUserData(params) {
    const res = await hitAxios({
      path: "/api/user/me",
      post: false,
      admin: false,
      showLoading: false,
    });
    if (res.data.success) {
      setAddon(res?.data?.addon);
      setUserData(res.data.data);
    }
  }

  React.useEffect(() => {
    updateUserData();
  }, []);

  const value = { updateUserData, userData, setUserData, addon };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

// Keep the old export for backward compatibility
export { UserContext };
